import React from 'react';
import StencilThickness from 'pu-react/components/StencilThickness';
import StencilFiducialData from 'pu-react/components/StencilFiducialData';
import StencilApproxSize from 'pu-react/components/StencilApproxSize';
import StencilFrameType from 'pu-react/components/StencilFrameType';
import StencilPrinterName from 'pu-react/components/StencilPrinterName';
import StencilManualPrinting from 'pu-react/components/StencilManualPrinting';

import FoilType from '../FoilType';
import ApertureCount from '../ApertureCount';

const FramelessSmtStencil = ({ product, onChangeParameter, parameters, reference, validator }) => {
  const groupName = `parameters[${reference + 1}]`;
  return (
    <div className="product-parameters row">
      <div className="col-lg-3">
        <FoilType
          groupName={groupName}
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Foil Type', parameters.foil_type, 'required')} />
      </div>
      <div className="col-lg-3">
        <ApertureCount
          groupName={groupName}
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Aperture Count', parameters.aperture_count, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilManualPrinting
          required={true}
          groupName={groupName}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Stencil Printer', parameters.manual_printing, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilApproxSize
          groupName={groupName}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Stencils Size', parameters.stencil_size, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilFrameType
          groupName={groupName}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Frame Type', parameters.frame_type, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilPrinterName
          groupName={groupName}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Printer Name', parameters.printer_type, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilThickness
          required={true}
          groupName={groupName}
          name="stencil_thickness"
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Stencils Thickness', parameters.stencil_thickness, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilFiducialData
          groupName={groupName}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Fiducial Data', parameters.fiducial_data, 'required')} />
      </div>
    </div>
  )
}

export default FramelessSmtStencil;
